var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container"},[_c('chart',{attrs:{"height":"100%","width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }